import * as React from "react"
import {Box, Grid, Typography} from "@mui/material";
import {formatPercentage} from "@ui-seeker/utils";
import {useComputed} from "@preact/signals-react";


export default function PricingCandlestickLegend({ minDiscount, maxDiscount }) {

    const isSameMinMax = maxDiscount === minDiscount
	const middleDiscount = Math.round( (minDiscount + maxDiscount) / 2)
    const minMiddleDiscount = Math.round( (minDiscount + middleDiscount) / 2)
	const maxMiddleDiscount = Math.round( (middleDiscount + maxDiscount) / 2)
	const zeroPosition = ((0 - minDiscount) / ( maxDiscount - minDiscount)) * 100
	const zeroDisplayLegend = maxDiscount !== 0
		&& minDiscount !== 0
		&& middleDiscount !== 0
		&& minMiddleDiscount !== 0
		&& maxMiddleDiscount !== 0
		&& !isSameMinMax

    return <Grid container spacing={0}>
        <Grid item xs={2} />
        <Grid item xs={10}>
            <Box sx={{ display: 'flex', position: 'relative', justifyContent: 'space-between', pl: 1, pt: 1.5 }}>
                {/*Fixed Always zero percentage*/}
                { zeroDisplayLegend && <LegendTypography sx={{ position: 'absolute', left: `${zeroPosition}%` }}>
                    {formatPercentage(0)}
                </LegendTypography> }

                <LegendTypography isMin isSameMinMax={isSameMinMax}> {formatPercentage(minDiscount)} </LegendTypography>
                <LegendTypography> {formatPercentage(minMiddleDiscount)} </LegendTypography>
                <LegendTypography> {formatPercentage(middleDiscount)} </LegendTypography>
                <LegendTypography> {formatPercentage(maxMiddleDiscount)} </LegendTypography>
                <LegendTypography> {formatPercentage(maxDiscount)} </LegendTypography>
            </Box>
        </Grid>
    </Grid>
}

const LegendTypography = ({ isMin=false, isSame, sx, children }) => {
    if (!isMin && isSame) return <></>

    return <Typography variant="caption" sx={{ color: "text.disabled", ...sx }}>
        {children}
    </Typography>
}